import React, { useState, useEffect } from 'react';
import { eventsService } from '../services/api';

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const response = await eventsService.getEvents();
        setEvents(response.data);
      } catch (err) {
        console.error('Error loading events:', err);
        setError('Error al cargar los eventos');
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);
  if (loading) return <div className="text-center py-12">Cargando eventos...</div>;
  if (error) return <div className="text-center py-12 text-red-600">{error}</div>;
  if (!events?.length) return null;

  return (
    <section className='bg-white'>
      <div className='max-w-6xl mx-auto px-4 py-12'>
        <h2 className='text-2xl font-bold mb-6'>Actividades</h2>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
          {events.map(e => (
            <div key={e.id} className='border rounded p-4'>
              <div className='text-sm text-gray-500'>{new Date(e.date).toLocaleDateString()} {new Date(e.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
              <div className='font-semibold mt-1'>{e.title}</div>
              <div className='text-sm text-gray-600 mt-2'>{e.location}</div>
              {/* <div className='mt-3'>
                <button className='px-3 py-2 border rounded text-sm'>Agregar al calendario</button>
                <button className='ml-2 px-3 py-2 border rounded text-sm'>Confirmar asistencia</button>
              </div> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
